import React from 'react'

export const DescriptionComments = ({ disabled, title, description }) => (
    <>
        <div >
            <span className={`text-[10px] md:text-[12px] font-semibold ${disabled && "text-[#9A9A9A]"}`}>{title}</span>
        </div>
        <div className='mb-2  leading-[8px] md:leading-3 flex  items-center'>
            <span className='text-[7px]  md:text-[10px] text-[#908080]'>{description}</span>
        </div>
    </>
)

